import { useEffect, useRef } from 'react';
import { Track } from '../types';

interface PlayedListProps {
  items: Array<{ number: number; track: Track | undefined }>;
}

/** Лента сыгранных песен: новые внизу. */
export const PlayedList = ({ items }: PlayedListProps) => {
  const listRef = useRef<HTMLOListElement>(null);

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    list.scrollTop = list.scrollHeight;
  }, [items.length]);

  return (
    <section className="played-list">
      <h2 className="played-list-title">Сыгранные песни</h2>
      {items.length === 0 ? (
        <p className="played-list-empty">Пока ничего не сыграно</p>
      ) : (
        <ol ref={listRef} className="played-list-items">
          {items.map(({ number, track }) => (
            <li key={number} className="played-list-item">
              #{number} — {track?.artist || '—'} — {track?.title || '—'}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
};
